import { render, staticRenderFns } from "./reserveAddGoodsDialog.vue?vue&type=template&id=3677be0a&"
import script from "./reserveAddGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./reserveAddGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports